// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyA9AXtFpn3g9xDrBaLG4_g1i6FMXEl5YwI",
    authDomain: "legal-council-secretary.firebaseapp.com",
    databaseURL: "https://legal-council-secretary.firebaseio.com",
    projectId: "legal-council-secretary",
    storageBucket: "legal-council-secretary.appspot.com",
    messagingSenderId: "874643766319",
    appId: "1:874643766319:web:7757a5774ccf30b1"
  },
  // websiteUrl: 'https://www.legalcouncilmef.com',
  // ssoIssuer: 'http://localhost:4000',
  // ssoLoginUrl: 'http://accounts.legalcouncilmef.com/login',
  // oauthClientId: 'legalcouncilmef-web',
  // oauthRedirectUri: 'https://www.legalcouncilmef.com/auth/callback',
  // publicUserApiBase: 'https://api.legalcouncilmef.com/public_users',
  // readerUrl: 'https://reader.legalcouncilmef.com'



  // websiteUrl: 'https://www.sathachak.com',
  // ssoIssuer: 'http://localhost:4000',
  // ssoLoginUrl: 'http://accounts.sathachak.com/login',
  // oauthClientId: 'sc-library-web',
  // oauthRedirectUri: 'https://www.sathachak.com/auth/callback',
  // publicUserApiBase: 'http://localhost:4000/public_users',
  // readerUrl: 'https://reader.sathachak.com',
  apiBaseUrl: 'https://api.sathachak.com',
  websiteUrl: 'https://www.sathachak.com',
  ssoIssuer: 'https://api.sathachak.com',
  ssoLoginUrl: 'https://accounts.sathachak.com/login',
  ssoDashboardUrl: 'https://accounts.sathachak.com/dashboard',
  oauthClientId: 'sc-library-web',
  oauthRedirectUri: 'https://www.sathachak.com/auth/callback',
  publicUserApiBase: 'https://api.sathachak.com/public_users',
  readerUrl: 'https://reader.sathachak.com/',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
